// extracted by mini-css-extract-plugin
export var hideEditor = "_j0-2";
export var infoIcon = "_j0-3";
export var label = "_j0-1";
export var labelContainer = "_j0-0";
export var readonlyText = "_j0-4";